// BUSINESS DESK — assistant de création : type → client → détails par activité → aperçu → émission.
import { useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { deskApi, fmtF, newIdempotencyKey, pdfUrl } from "./deskApi";

const num = (v) => {
  const n = parseFloat(String(v).replace(",", "."));
  return Number.isFinite(n) && n >= 0 ? n : 0;
};
const int = (v) => Math.round(num(v));
const nightsBetween = (a, b) => {
  if (!a || !b) return 0;
  const d = Math.round((new Date(b) - new Date(a)) / 86400000);
  return d > 0 ? d : 0;
};

// ── Étape 2 : client ──
function CustomerStep({ onPick }) {
  const [q, setQ] = useState("");
  const [customers, setCustomers] = useState([]);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", address: "", country: "Côte d'Ivoire", company_name: "" });

  useEffect(() => {
    const t = setTimeout(() => {
      deskApi(`/customers?q=${encodeURIComponent(q)}`).then((d) => setCustomers(d.customers)).catch(() => {});
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  const create = async () => {
    try {
      const d = await deskApi("/customers", { method: "POST", body: form });
      onPick(d.customer);
    } catch (e) { toast.error(e.message); }
  };

  if (creating) {
    return (
      <div className="desk-card" data-testid="desk-new-customer-form">
        <h3 style={{ margin: 0 }}>Nouveau client</h3>
        <div className="desk-field"><label>Nom complet *</label>
          <input className="desk-input" data-testid="desk-customer-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Ex : Mme Koné Awa" /></div>
        <div className="desk-row2">
          <div className="desk-field"><label>Téléphone</label>
            <input className="desk-input" data-testid="desk-customer-phone-input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+225…" /></div>
          <div className="desk-field"><label>Pays</label>
            <input className="desk-input" data-testid="desk-customer-country-input" value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} /></div>
        </div>
        <div className="desk-field"><label>Adresse</label>
          <input className="desk-input" data-testid="desk-customer-address-input" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} placeholder="Quartier, ville" /></div>
        <div className="desk-field"><label>Société (optionnel)</label>
          <input className="desk-input" value={form.company_name} onChange={(e) => setForm({ ...form, company_name: e.target.value })} /></div>
        <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
          <button className="desk-btn desk-btn-outline desk-btn-sm" onClick={() => setCreating(false)}>Annuler</button>
          <button className="desk-btn desk-btn-gold" data-testid="desk-customer-create-btn" disabled={!form.name.trim()} onClick={create}>Enregistrer le client</button>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="desk-customer-step">
      <div className="desk-field">
        <input className="desk-input" data-testid="desk-customer-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="🔍 Rechercher un client (nom, téléphone)…" />
      </div>
      <button className="desk-btn desk-btn-dark" style={{ marginTop: 12 }} data-testid="desk-add-customer-btn" onClick={() => setCreating(true)}>
        ➕ Nouveau client
      </button>
      {customers.map((c) => (
        <div key={c.customer_id} className="desk-doc-card" style={{ cursor: "pointer" }} data-testid={`desk-customer-${c.customer_id}`} onClick={() => onPick(c)}>
          <div className="desk-doc-number">{c.name}</div>
          <div className="desk-doc-client">{[c.phone, c.address, c.country].filter(Boolean).join(" · ")}</div>
        </div>
      ))}
      {customers.length === 0 && <div className="desk-empty">Aucun client trouvé.</div>}
    </div>
  );
}

// ── Étape 3 : formulaires par activité ──
function ResidenceForm({ d, set }) {
  const nights = nightsBetween(d.arrival, d.departure);
  return (
    <>
      <div className="desk-field"><label>Nom de la résidence *</label>
        <input className="desk-input" data-testid="desk-res-name-input" value={d.residence || ""} onChange={(e) => set({ residence: e.target.value })} placeholder="Ex : Résidence Les Palmiers" /></div>
      <div className="desk-row2">
        <div className="desk-field"><label>Arrivée *</label>
          <input type="date" className="desk-input" data-testid="desk-res-arrival-input" value={d.arrival || ""} onChange={(e) => set({ arrival: e.target.value })} /></div>
        <div className="desk-field"><label>Départ *</label>
          <input type="date" className="desk-input" data-testid="desk-res-departure-input" value={d.departure || ""} onChange={(e) => set({ departure: e.target.value })} /></div>
      </div>
      <div className="desk-row2">
        <div className="desk-field"><label>Nuits (auto)</label>
          <input className="desk-input" data-testid="desk-res-nights" value={nights || ""} readOnly style={{ background: "#F2EEE2" }} /></div>
        <div className="desk-field"><label>Tarif / nuit (FCFA) *</label>
          <input inputMode="numeric" className="desk-input" data-testid="desk-res-price-input" value={d.pricePerNight || ""} onChange={(e) => set({ pricePerNight: e.target.value })} placeholder="45 000" /></div>
      </div>
      <div className="desk-field"><label>Frais additionnels (optionnel)</label>
        <div className="desk-row2">
          <input className="desk-input" data-testid="desk-res-fee-label-input" value={d.feeLabel || ""} onChange={(e) => set({ feeLabel: e.target.value })} placeholder="Ex : Ménage" />
          <input inputMode="numeric" className="desk-input" data-testid="desk-res-fee-amount-input" value={d.feeAmount || ""} onChange={(e) => set({ feeAmount: e.target.value })} placeholder="Montant FCFA" />
        </div></div>
    </>
  );
}

function CeremonyForm({ d, set, catalog }) {
  const items = d.items || [];
  const addItem = (name) => set({ items: [...items, { name, qty: "", price: "" }] });
  const upd = (i, patch) => set({ items: items.map((it, k) => (k === i ? { ...it, ...patch } : it)) });
  const del = (i) => set({ items: items.filter((_, k) => k !== i) });
  return (
    <>
      <div className="desk-field"><label>Matériel — touchez pour ajouter</label>
        <div className="desk-chips" data-testid="desk-cer-catalog">
          {catalog.map((c) => (
            <button key={c} className="desk-chip" data-testid={`desk-cer-chip-${c}`} onClick={() => addItem(c)}>{c}</button>
          ))}
          <button className="desk-chip" data-testid="desk-cer-chip-autre" onClick={() => addItem("")}>➕ Autre</button>
        </div></div>
      {items.map((it, i) => (
        <div key={i} className="desk-card" style={{ padding: 12 }} data-testid={`desk-cer-item-${i}`}>
          <input className="desk-input" value={it.name} onChange={(e) => upd(i, { name: e.target.value })} placeholder="Nom du matériel" />
          <div className="desk-row2" style={{ marginTop: 8 }}>
            <input inputMode="numeric" className="desk-input" data-testid={`desk-cer-qty-${i}`} value={it.qty} onChange={(e) => upd(i, { qty: e.target.value })} placeholder="Quantité" />
            <input inputMode="numeric" className="desk-input" data-testid={`desk-cer-price-${i}`} value={it.price} onChange={(e) => upd(i, { price: e.target.value })} placeholder="Prix unitaire FCFA" />
          </div>
          <button className="dl-del" style={{ marginTop: 6, background: "none", border: "none", color: "#C0392B", fontSize: 12, fontWeight: 700, cursor: "pointer" }} onClick={() => del(i)}>Retirer</button>
        </div>
      ))}
      <div className="desk-row2">
        <div className="desk-field"><label>Début location</label>
          <input type="date" className="desk-input" data-testid="desk-cer-start-input" value={d.start || ""} onChange={(e) => set({ start: e.target.value })} /></div>
        <div className="desk-field"><label>Fin location</label>
          <input type="date" className="desk-input" data-testid="desk-cer-end-input" value={d.end || ""} onChange={(e) => set({ end: e.target.value })} /></div>
      </div>
      <div className="desk-field"><label>Dépôt de garantie FCFA (optionnel)</label>
        <input inputMode="numeric" className="desk-input" data-testid="desk-cer-deposit-input" value={d.deposit || ""} onChange={(e) => set({ deposit: e.target.value })} placeholder="Remboursable au retour" /></div>
    </>
  );
}

function ExportForm({ d, set }) {
  return (
    <>
      <div className="desk-row2">
        <div className="desk-field"><label>Produit *</label>
          <input className="desk-input" data-testid="desk-exp-product-input" value={d.product ?? "Attiéké"} onChange={(e) => set({ product: e.target.value })} /></div>
        <div className="desk-field"><label>Pays de destination *</label>
          <input className="desk-input" data-testid="desk-exp-country-input" value={d.destination || ""} onChange={(e) => set({ destination: e.target.value })} placeholder="Ex : France" /></div>
      </div>
      <div className="desk-row2">
        <div className="desk-field"><label>Poids (kg) *</label>
          <input inputMode="decimal" className="desk-input" data-testid="desk-exp-weight-input" value={d.weight || ""} onChange={(e) => set({ weight: e.target.value })} placeholder="Ex : 250" /></div>
        <div className="desk-field"><label>Prix / kg (FCFA) *</label>
          <input inputMode="numeric" className="desk-input" data-testid="desk-exp-price-input" value={d.pricePerKg || ""} onChange={(e) => set({ pricePerKg: e.target.value })} placeholder="Ex : 1 500" /></div>
      </div>
      <div className="desk-row2">
        <div className="desk-field"><label>Frais d'expédition FCFA</label>
          <input inputMode="numeric" className="desk-input" data-testid="desk-exp-shipping-input" value={d.shipping || ""} onChange={(e) => set({ shipping: e.target.value })} placeholder="0" /></div>
        <div className="desk-field"><label>Référence lot (optionnel)</label>
          <input className="desk-input" data-testid="desk-exp-lot-input" value={d.lot || ""} onChange={(e) => set({ lot: e.target.value })} /></div>
      </div>
      <div className="desk-field"><label>Taux EUR indicatif (1 € = … FCFA)</label>
        <input inputMode="decimal" className="desk-input" data-testid="desk-exp-eurrate-input" value={d.eurRate ?? "655.957"} onChange={(e) => set({ eurRate: e.target.value })} /></div>
    </>
  );
}

// ── Construction des lignes (affichage local — les totaux officiels sont recalculés serveur) ──
function buildLines(activityId, d) {
  const fmtDate = (x) => (x ? new Date(x).toLocaleDateString("fr-FR") : "");
  if (activityId === "res") {
    const nights = nightsBetween(d.arrival, d.departure);
    const lines = [];
    if (d.residence && nights > 0 && int(d.pricePerNight) > 0) {
      lines.push({ description: `Résidence « ${d.residence} » — du ${fmtDate(d.arrival)} au ${fmtDate(d.departure)}`, quantity: nights, unit: "nuits", unit_price_minor: int(d.pricePerNight) });
    }
    if (d.feeLabel && int(d.feeAmount) > 0) lines.push({ description: d.feeLabel, quantity: 1, unit: "", unit_price_minor: int(d.feeAmount) });
    return lines;
  }
  if (activityId === "cer") {
    const period = d.start && d.end ? ` (du ${fmtDate(d.start)} au ${fmtDate(d.end)})` : "";
    const lines = (d.items || [])
      .filter((it) => it.name.trim() && num(it.qty) > 0 && int(it.price) >= 0)
      .map((it) => ({ description: `${it.name.trim()}${period}`, quantity: num(it.qty), unit: "", unit_price_minor: int(it.price) }));
    if (int(d.deposit) > 0) lines.push({ description: "Dépôt de garantie (remboursable au retour du matériel)", quantity: 1, unit: "", unit_price_minor: int(d.deposit) });
    return lines;
  }
  if (activityId === "exp") {
    const lines = [];
    if (num(d.weight) > 0 && int(d.pricePerKg) > 0) {
      lines.push({ description: `${(d.product ?? "Attiéké").trim() || "Attiéké"} — export ${d.destination || "?"}${d.lot ? ` (lot ${d.lot})` : ""}`, quantity: num(d.weight), unit: "kg", unit_price_minor: int(d.pricePerKg) });
    }
    if (int(d.shipping) > 0) lines.push({ description: "Frais d'expédition", quantity: 1, unit: "", unit_price_minor: int(d.shipping) });
    return lines;
  }
  return [];
}

export default function DeskWizard({ profile, onDone }) {
  const [step, setStep] = useState(1);
  const [docType, setDocType] = useState("INVOICE");
  const [activity, setActivity] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [details, setDetails] = useState({});
  const [discount, setDiscount] = useState("");
  const [notes, setNotes] = useState("");
  const [issued, setIssued] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const activities = (profile?.activities || []).filter((a) => a.active);
  const catalog = activities.find((a) => a.activity_id === "cer")?.configuration?.catalog || [];
  const set = (patch) => setDetails((d) => ({ ...d, ...patch }));

  const lines = useMemo(() => buildLines(activity?.activity_id, details), [activity, details]);
  const subtotal = lines.reduce((s, l) => s + Math.round(l.quantity * l.unit_price_minor), 0);
  const total = Math.max(0, subtotal - int(discount));

  const issue = async () => {
    setBusy(true);
    try {
      const body = {
        activity_id: activity.activity_id,
        customer_id: customer.customer_id,
        document_type: docType,
        lines,
        discount_minor: int(discount),
        notes,
        meta: details,
      };
      if (activity.activity_id === "exp" && num(details.eurRate ?? "655.957") > 0) body.eur_rate = num(details.eurRate ?? "655.957");
      const draft = await deskApi("/documents/draft", { method: "POST", body });
      const r = await deskApi(`/documents/${draft.document.document_id}/issue`, {
        method: "POST",
        body: { confirm: true },
        idempotency: newIdempotencyKey(),
      });
      setIssued(r.document);
      setConfirmOpen(false);
      toast.success(`${docType === "QUOTE" ? "Devis" : "Facture"} ${r.document.document_number} émis(e) ✓`);
    } catch (e) {
      toast.error(e.message);
      setConfirmOpen(false);
    } finally {
      setBusy(false);
    }
  };

  if (issued) {
    return (
      <div className="desk-success" data-testid="desk-issue-success">
        <div className="dsx-icon">🎉</div>
        <h2>{docType === "QUOTE" ? "Devis émis" : "Facture émise"}</h2>
        <div className="dsx-number" data-testid="desk-issued-number">{issued.document_number}</div>
        <p style={{ color: "#A79A7B", fontSize: 14 }}>{fmtF(issued.total_minor)} — {issued.customer_snapshot?.name}</p>
        <a className="desk-btn desk-btn-gold" style={{ marginTop: 10, textDecoration: "none" }} data-testid="desk-issued-pdf-btn" href={pdfUrl(issued.document_id)} target="_blank" rel="noreferrer">
          📄 Voir le PDF
        </a>
        <button className="desk-btn desk-btn-outline" style={{ marginTop: 10 }} data-testid="desk-issued-done-btn" onClick={onDone}>
          Terminer
        </button>
      </div>
    );
  }

  return (
    <div data-testid="desk-wizard">
      <div className="desk-steps">
        {[1, 2, 3, 4].map((i) => <span key={i} className={`desk-step-dot ${step >= i ? "done" : ""}`} />)}
      </div>

      {step === 1 && (
        <>
          <h3>Que voulez-vous créer ?</h3>
          <div className="desk-choice-grid">
            {[{ id: "QUOTE", icon: "📝", label: "Devis" }, { id: "INVOICE", icon: "🧾", label: "Facture" }].map((t) => (
              <button key={t.id} className={`desk-choice ${docType === t.id ? "selected" : ""}`} data-testid={`desk-type-${t.id}`} onClick={() => setDocType(t.id)}>
                <span className="dc-icon">{t.icon}</span>{t.label}
              </button>
            ))}
          </div>
          <h3 style={{ marginTop: 22 }}>Pour quelle activité ?</h3>
          <div className="desk-choice-grid">
            {activities.map((a) => (
              <button key={a.activity_id} className={`desk-choice ${activity?.activity_id === a.activity_id ? "selected" : ""}`} data-testid={`desk-activity-${a.activity_id}`} onClick={() => setActivity(a)}>
                <span className="dc-icon">{a.icon || "💼"}</span>
                {a.name}
              </button>
            ))}
          </div>
          <button className="desk-btn desk-btn-gold" style={{ marginTop: 20 }} data-testid="desk-step1-next-btn" disabled={!activity} onClick={() => setStep(2)}>
            Continuer →
          </button>
          <p className="desk-note">💡 Le reçu de paiement se crée depuis une facture émise (onglet Documents → Encaisser).</p>
        </>
      )}

      {step === 2 && (
        <>
          <h3>Qui est le client ?</h3>
          <CustomerStep onPick={(c) => { setCustomer(c); setStep(3); }} />
          <button className="desk-btn desk-btn-outline" style={{ marginTop: 14 }} onClick={() => setStep(1)}>← Retour</button>
        </>
      )}

      {step === 3 && (
        <>
          <h3>{activity.icon} {activity.name}</h3>
          <p className="desk-note" style={{ marginTop: 0 }}>Client : <b>{customer.name}</b></p>
          {activity.activity_id === "res" && <ResidenceForm d={details} set={set} />}
          {activity.activity_id === "cer" && <CeremonyForm d={details} set={set} catalog={catalog} />}
          {activity.activity_id === "exp" && <ExportForm d={details} set={set} />}
          <div className="desk-field"><label>Remise FCFA (optionnel)</label>
            <input inputMode="numeric" className="desk-input" data-testid="desk-discount-input" value={discount} onChange={(e) => setDiscount(e.target.value)} placeholder="0" /></div>
          <div className="desk-field"><label>Notes / conditions (optionnel)</label>
            <textarea className="desk-textarea" rows={2} data-testid="desk-notes-input" value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Ex : Acompte de 50% à la commande" /></div>
          <div className="desk-total-box" data-testid="desk-live-total">
            <span className="dt-label">TOTAL</span>
            <span className="dt-value">{fmtF(total)}</span>
          </div>
          <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
            <button className="desk-btn desk-btn-outline desk-btn-sm" onClick={() => setStep(2)}>← Retour</button>
            <button className="desk-btn desk-btn-gold" data-testid="desk-step3-next-btn" disabled={lines.length === 0} onClick={() => setStep(4)}>
              Aperçu →
            </button>
          </div>
        </>
      )}

      {step === 4 && (
        <>
          <h3>Aperçu — {docType === "QUOTE" ? "Devis" : "Facture"}</h3>
          <div className="desk-card" data-testid="desk-preview-card">
            <div className="desk-doc-number">{customer.name}</div>
            <div className="desk-doc-client">{activity.name} · {new Date().toLocaleDateString("fr-FR")}</div>
            <div style={{ marginTop: 10 }}>
              {lines.map((l, i) => (
                <div key={i} className="desk-line">
                  <span className="dl-desc">{l.description} <span style={{ color: "#A79A7B", fontWeight: 500 }}>× {l.quantity}{l.unit ? ` ${l.unit}` : ""}</span></span>
                  <span className="dl-amount">{fmtF(Math.round(l.quantity * l.unit_price_minor))}</span>
                </div>
              ))}
            </div>
            {int(discount) > 0 && (
              <div className="desk-line"><span className="dl-desc">Remise</span><span className="dl-amount" style={{ color: "#C0392B" }}>- {fmtF(int(discount))}</span></div>
            )}
            <div className="desk-total-box"><span className="dt-label">TOTAL</span><span className="dt-value">{fmtF(total)}</span></div>
            {notes && <p className="desk-note">📝 {notes}</p>}
          </div>
          <p className="desk-note">Le numéro définitif sera attribué uniquement à l'émission.</p>
          <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
            <button className="desk-btn desk-btn-outline desk-btn-sm" onClick={() => setStep(3)}>← Modifier</button>
            <button className="desk-btn desk-btn-gold" data-testid="desk-open-issue-confirm-btn" onClick={() => setConfirmOpen(true)}>
              Émettre {docType === "QUOTE" ? "le devis" : "la facture"} ✓
            </button>
          </div>
        </>
      )}

      {confirmOpen && (
        <div className="desk-modal-overlay" onClick={() => !busy && setConfirmOpen(false)}>
          <div className="desk-modal" onClick={(e) => e.stopPropagation()} data-testid="desk-issue-confirm-modal">
            <h3>Confirmer l'émission ?</h3>
            <p className="dm-sub">Un numéro officiel sera attribué à ce document ({fmtF(total)}). Cette action est enregistrée et le document ne pourra plus être supprimé, seulement annulé avec justification.</p>
            <button className="desk-btn desk-btn-gold" data-testid="desk-confirm-issue-btn" disabled={busy} onClick={issue}>
              {busy ? "Émission…" : "Oui, émettre maintenant"}
            </button>
            <button className="desk-btn desk-btn-outline" style={{ marginTop: 8 }} disabled={busy} onClick={() => setConfirmOpen(false)}>Pas encore</button>
          </div>
        </div>
      )}
    </div>
  );
}
